var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material__author"},[_c('img',{attrs:{"src":require("../../../assets/images/material-avatar.svg"),"alt":"avatar"}}),_vm._v(" "),_c('p',[_vm._v("Автор редакции")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.material.authorName || 'Редакция «за школой»'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }